import {NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';

import {LinkButtonComponent} from '@q9elements/ui-kit/components';
import {SfRefModelNode} from '../models/org-node-link.interface';

@Component({
  selector: 'app-sf-node-info',
  templateUrl: './sf-node-info.component.html',
  styleUrls: ['./sf-node-info.component.scss'],
  imports: [
    LinkButtonComponent,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    NgIf,
    MatDividerModule,
    MatMenuModule
  ],
  standalone: true
})
export class SfNodeInfoComponent {
  @Input() rmn: SfRefModelNode;

  public hasSfSetupPageLink(): boolean {
    const link =
      this.rmn.linkType !== 'Classic' && this.rmn.lightningExternalUrl
        ? this.rmn.lightningExternalUrl
        : this.rmn.externalUrl;

    return Boolean(link);
  }

  openSFSetupPage() {
    const {linkType, externalUrl, lightningExternalUrl} = this.rmn;
    const url = linkType === 'Classic' ? externalUrl : lightningExternalUrl;

    window.open(url);
  }
}
